import {defineStore} from 'pinia'
import helpers from "./storeHelpers";

export const usePointStore = defineStore('pointStore', {
  state: () => ({
    points: [],
    products: {
      heading: "Select machines", list: []
    },
    categories: {
      heading: "Select categories", list: []
    },
    selectedCategories: [], 
    depths: {
      heading: "Select depth range", list: []
    },
    search: {
      heading: "Search results", showing: "Showing", results: "results", natch: "matching"
    },
    filter: {
      clear: "Clear", filterHeading: "Filter Heading", filterText: "Filter Text"
    }
  }),

  getters: {
    searchResults: (state) => {
      let pointsNumber = 0;
      for (let i = 0; i < state.points.length ?? 0; i++) {
        if (!state.points[i].disabled) {
          pointsNumber++;
        }
      }
      return pointsNumber;
    },

    selectedProducts: (state) => {
      const productArray = [];
      for (let i = 0; i < state.products?.list?.length ?? 0; i++) {
        if (state.products.list[i].selected) {
          productArray.push(state.products.list[i]);
        }
      }
      return productArray;
    },
    selectedDepths: (state) => {
      const depthArray = [];
      for (let i = 0; i < state.depths?.list?.length ?? 0; i++) {
        if (state.depths.list[i].selected) {
          depthArray.push(state.depths.list[i]);
        }
      }
      return depthArray;
    },
    selectedCategories: (state) => {
      const categoryArray = [];
      for (let i = 0; i < state?.categories?.list?.length ?? 0; i++) {
        if (state.categories.list[i].selected) {
          categoryArray.push(state.categories.list[i]);
        }
      }
      return categoryArray;
    },
    enabledPoints: (state) => {
      const pointArray = [];
      for (let i = 0; i < state.points?.length ?? 0; i++) {
        if (state.points[i].disabled === false) {
          pointArray.push(state.points[i]);
        }
      }
      return pointArray;
    },
    selectedPoint: (state) => {
      let pointNumber = 0;
      const pointArray = [];
      for (let i = 0; i < state.points?.length ?? 0; i++) {
        if (state.points[i].selected) {
          pointNumber++;
          pointArray.push(state.points[i]);
        }
      }
      if (pointNumber === 1) {
        return pointArray[0];
      } else {
        return '';
      }
    }

  }, actions: {
    setInitialState() {
      helpers.getPoints().then((data) => {
        this.points = data;
      }), helpers.getProducts().then((data) => {
        this.products = data;
      }), helpers.getCategories().then((data) => {
        this.categories = data;
      }), helpers.getDepths().then((data) => {
        this.depths = data;
      }), helpers.getSearch().then((data) => {
        this.search = data;
      }), helpers.getFilter().then((data) => {
        this.filter = data;
      })
    },
  }
});